var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OrdersList',{attrs:{"data-testid":"orders-section","orders":_vm.orders,"loading":_vm.loading,"error":_vm.error,"view-more-href":_vm.ordersPageHref},on:{"on-retry":_vm.handleOnRetry,"on-view-more-click":_vm.handleOnViewMoreClick,"on-order-click":_vm.handleOnOrderClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }